import { QueryClient } from '@tanstack/react-query';

// Short TTL to avoid stale admin data; refetch on window focus
export const adminQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30s
      refetchOnWindowFocus: true,
      retry: 1
    }
  }
});
